// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
import amplitude from 'amplitude-js';
const Planners = ApiFactory.get('planners');
const Trips = ApiFactory.get('trips');
const Stops = ApiFactory.get('stops');
const Quotes = ApiFactory.get('quotes');

const createPlanner = async ( { commit }, payload) => {
  const { data } = await Planners.post(payload);
  amplitude.getInstance().logEvent('CREATE_PLANNER');
  commit("SET_PLANNER", data);
};

const createTrip = async ( { commit }, payload) => {
  const { data } = await Trips.post(payload);
  amplitude.getInstance().logEvent('CREATE_TRIP');
  commit('SET_TRIP', data);
  commit('SET_DEAD_HEADS', data.dead_heads);
  commit('SET_ROUTE', data.route);
};
const fetchStops = async ( { commit }, qs) => {
  const { data } = await Stops.get(qs);
  commit('SET_STOPS', data);
};
const updateStop = async ( { commit }, payload) => {
  const { data } = await Stops.update(payload.id, payload);
  amplitude.getInstance().logEvent('UPDATE_STOP');
  commit('UPDATE_STOPS_BY_ID', data);
};
const createQuote = async ( {commit}, payload)=> {
  delete payload.trip.trip_planner.user;
  const { data } = await Quotes.post(payload);
  amplitude.getInstance().logEvent('CREATE_QUOTE');
  commit('SET_QUOTE', data);
};

const updateBusTypes = async ({ commit }, payload) => {
  const { data } = await Trips.update(payload.id, payload);
  amplitude.getInstance().logEvent('BUSES_ADDED');
  commit('SET_TRIP', data);
}

const clearData = ( { commit } ) => {
  commit('SET_PLANNER', {});
  commit('SET_TRIP', {});
  commit('SET_STOPS', []);
  commit('SET_QUOTE', {});
};

export default {
  createPlanner,
  createTrip,
  fetchStops,
  updateStop,
  createQuote,
  clearData,
  updateBusTypes
};
